import React from 'react';

import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type PropertyInformationDataType = {
  buildingName: string;
  buildingAddress: string;
};

const PropertyInformation = ({
  buildingName,
  buildingAddress,
}: PropertyInformationDataType) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        PROPERTY INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>

        <InfoRowStyled>
          <Typography className="title">Property Address :</Typography>
          <Typography className="value">{buildingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default PropertyInformation;
